export default __webpack_public_path__ + "static/media/seashell2.5f1c86f9.svg";